/* eslint-disable react/no-array-index-key */
import React, { PureComponent } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { map, sum } from 'lodash';

import { withTranslation } from 'react-i18next';
import {
    Area, AreaChart, ResponsiveContainer, Tooltip,
} from 'recharts';

import PropTypes, {array} from 'prop-types';

const CustomTooltip = ({ active, payload }) => {
    if (active) {
        return (
            <div className="dashboard__total-tooltip">
                <p className="label">{`${payload[0].value}`}</p>
            </div>
        );
    }

    return null;
};

CustomTooltip.propTypes = {
    active: PropTypes.bool,
    payload: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.number,
    })),
};

CustomTooltip.defaultProps = {
    active: false,
    payload: null,
};

class AnalysisSummary extends PureComponent {
    static propTypes = {
        dir: PropTypes.string.isRequired,
    };

  constructor(props) {
    super(props);
    this.state = {
        activeIndex: 0,
    };
  }

  render() {
      const { dir, data, title } = this.props;
      const { activeIndex } = this.state;

      let icon = "icon-6.png";
      let stroke = "#73c5da";
      let fill = "#73c5da";
      let colorClass = "";
      if(data['Percentage Change'] < 0){
          icon = "icon-7.png";
          stroke = "#5e8ba3";
          fill = "#5e8ba3";
          colorClass = "colorTeal";
      }

      const dataConvertChartArray = map(data.Timestamp , (item, index)=> {
          return {
            "Data": data['Data'][index], "Timestamp": item
          }
      });

    return (
        <div className="white-bg">
          <h6>{title}</h6>
          <h4>{data['Last Period']}</h4>
          <h6 className={`text ${colorClass}`}>{`${data['Percentage Change']}%`} <img src={`img/${icon}`} alt="" /></h6>
            <div className="dashboard__table-crypto-chart analysis-trend-chart">
                <ResponsiveContainer height={36}>
                    <AreaChart data={dataConvertChartArray} margin={{ top: 0, left: 0, bottom: 0 }}>
                        <Tooltip content={<CustomTooltip />} />
                        <Area
                            type="monotone"
                            dataKey="Data"
                            fill={fill}
                            stroke={stroke}
                            fillOpacity={0.2}
                        />
                    </AreaChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
  }
}


export default withTranslation('common')(AnalysisSummary);
